import React, { createContext, useContext, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PrivateNoticesUIHelpers";

const PrivateNoticesUIContext = createContext();

export function usePrivateNoticesUIContext() {
  return useContext(PrivateNoticesUIContext);
}

export const PrivateNoticesUIConsumer = PrivateNoticesUIContext.Consumer;

export function PrivateNoticesUIProvider({ privateNoticesUIEvents, children }) {
  const { user } = useSelector(state => state.auth);
  initialFilter.term = user.currentActiveTerm; // Mevcut Aktif Dönem Atanıyor
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);
  
  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openNewPrivateNoticePage: privateNoticesUIEvents.openNewPrivateNoticePage,
    openPrivateNoticeDetailPage: privateNoticesUIEvents.openPrivateNoticeDetailPage
  };

  return (
    <PrivateNoticesUIContext.Provider value={value}>
      {children}
    </PrivateNoticesUIContext.Provider>
  );
}